export const clearCookies = () => {
  const cookieDomainEnv = import.meta.env.VITE_COOKIE_DOMAIN;
  const cookieDomain = cookieDomainEnv ? `; domain=${cookieDomainEnv}` : '';

  const cookiesToClear = ['Metbus.AuthToken', 'Metbus.RefreshToken'];

  cookiesToClear.forEach((cookieName) => {
    document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${cookieDomain}`;
    document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
};
